var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot-selector flex-centerize"},_vm._l((_vm.dotArray),function(dot,index){return _c('div',{key:index},[_c('div',{staticClass:"dot-container"},[_c('div',{staticClass:"dot",class:{ 'is-current': _vm.currentDotIndex === index },on:{"click":function($event){return _vm.$emit('dotClicked', index)}}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }